import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleChoiceItem } from '../../Redux/Slice/selectedProductsSlice';
import { getNoImageSVG, handleImageError } from '../../utils/imageUtils';

const ChoiceItem = ({ choice, sectionId, onSelect, forceSelected }) => {
  const dispatch = useDispatch();
  const { selectedChoices } = useSelector(state => state.selectedProducts);

  const isPlanSelected = selectedChoices.some(selected => selected.id === choice.id);
  const isSelected = forceSelected !== undefined ? forceSelected : isPlanSelected;

  const handleClick = () => {
    dispatch(toggleChoiceItem({ choice, sectionId }));
    if (onSelect) {
      onSelect(!isSelected);
    }
  };

  const displayImage = choice.image || choice.profile_image || getNoImageSVG();

  return (
    <div className="col-md-3 col-sm-6 col-12 px-3 mb-4">
      <div
        className={`border product-card pt-3 h-100 ${isSelected ? 'active' : ''}`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
          }
        }}
      >
        <div className="d-flex flex-column">
          <div className="image px-3 pb-3 flex-grow-1">
            <img
              src={displayImage}
              alt={choice.label}
              className="img-fluid h-100"
              onError={handleImageError}
              style={{ objectFit: 'cover', minHeight: '200px' }}
            />
          </div>
          <div className="description px-3 flex-grow-1 d-flex flex-column justify-content-between" style={{ overflowWrap: 'break-word' }}>
            <div>
              <p className="product-name mb-2">{choice.label}</p>
              {choice.help_text && (
                <p className="product-description mb-2 text-muted small" style={{ fontSize: '0.8rem' }}>
                  {choice.help_text}
                </p>
              )}
              {choice.code && (
                <p className="product-sku mb-2 text-muted small" style={{ fontSize: '0.7rem' }}>
                  Code: {choice.code}
                </p>
              )}
            </div>
            <div className="d-flex justify-content-between align-items-center">
              {choice.add_quantities && (
                <span className="badge bg-secondary">
                  Quantité ajustable
                </span>
              )}
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  className="custom-checkbox"
                  checked={isSelected}
                  onChange={handleClick}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChoiceItem;

